import React from 'react'
import { LinkButton } from '@enamelai/design-system'
import { Icon as AddIcon } from '@enamelai/design-system/icons/Add'
import './TxPlanAddPhaseRow.css'

interface TxPlanAddPhaseRowProps {
  onAddPhase: () => void
}

const TxPlanAddPhaseRow = ({
  onAddPhase,
}: TxPlanAddPhaseRowProps): React.ReactElement => {
  return (
    <div className="tx-plan-add-phase-row">
      <LinkButton
        type="button"
        size="sm"
        underline={false}
        aria-label="Add phase to this plan"
        leftIcon={<AddIcon width={16} height={16} aria-hidden />}
        onClick={onAddPhase}
      >
        Add phase
      </LinkButton>
    </div>
  )
}

export default TxPlanAddPhaseRow
